import { ProductEffects } from './product.effects';
export const effects: any[] = [ProductEffects];
